import type { FC, ReactNode } from 'react';

import type { ContextModalProps } from '@mantine/modals';

const InfoModal: FC<
    ContextModalProps & {
        innerProps: {
            children: ReactNode;
        };
    }
> = ({ innerProps }) => {
    return <>{innerProps.children}</>;
};

export { InfoModal };
